export default {
  getAllActivityTypes: state => state.activityTypes,
  getCurrentActivityType: state => state.currentActivityType,
  getCurrentActivityTypeObj: state => state.currentActivityTypeObj
}
